// ------------------------------------
// EXIBIÇÃO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'depoimentos-var';
    const ref2 = 'depoimentos';
    const refEvtPrefix = 'lp-evt-depoimentos-';

    // Elementos
    const $section = $('#depoimentos');

    // Oculta/Exibe a seção
    function changeSecShow() {
      const value = confTheme[ref2]['depoimentos-show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'show', changeSecShow);
  }
})();

// ------------------------------------
// PLANO DE FUNDO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'depoimentos-var';
    const ref2 = 'depoimentos';
    const refEvtPrefix = 'lp-evt-depoimentos-';

    // Elementos
    const $section = $('#depoimentos');

    // Altera o tipo de fundo
    function changeBgType() {
      const value = confTheme[ref2]['bg-type'];
      if (value == 'image') {
        changeBgImage();
      } else if (value == 'gradient') {
        changeBgGradient();
      } else if (value == 'color') {
        changeBgColor();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'bg-type', changeBgType);

    // Altera a imagem de fundo
    function changeBgImage() {
      const image = confTheme[ref2]['bg-image'];
      $section.css('background-image', 'url(' + image + ')');
    }
    $root.on(refEvtPrefix + 'bg-image', changeBgImage);

    // Altera o gradiente de fundo
    function changeBgGradient() {
      const value = confTheme[ref2]['bg-gradient'];
      $section.css('background-image', value);
    }
    $root.on(refEvtPrefix + 'bg-gradient', changeBgGradient);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref]['depoimentos-bg-color'];
      $section.css('background-image', 'none');
      $section[0].style.setProperty('--depoimentos-bg-color', color);
    }
    $root.on(refEvtPrefix + 'bg-color', changeBgColor);
  }
})();

// ------------------------------------
// TIPO DE CONTEÚDO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'depoimentos-var';
    const ref2 = 'depoimentos';
    const refEvtPrefix = 'lp-evt-depoimentos-';

    // Elementos
    const $section = $('#depoimentos');

    // Altera o título
    function changeSectinTypeContent() {
      const value = confTheme[ref2]['tipo_conteudo'];
      $section.removeClass('depoimentos-opt-1 depoimentos-opt-2 depoimentos-opt-3').addClass(value);
      depoimentosDestroySlick();
      depoVideosDestroySlick();
      depoImagensDestroySlick();
      if (value == 'depoimentos-opt-1') {
        depoimentosInitSlick();
      }
      // Vídeos
      else if (value == 'depoimentos-opt-2') {
        depoVideosInitSlick();
      }
      // Imagens
      else if (value == 'depoimentos-opt-3') {
        depoImagensInitSlick();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tipo-conteudo', changeSectinTypeContent);
  }
})();

// ------------------------------------
// TEXTOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'depoimentos-var';
    const ref2 = 'depoimentos';
    const refEvtPrefix = 'lp-evt-depoimentos-';

    // Elementos
    const $section = $('#depoimentos');
    const $secTitle = $('.depoimentos-titulo');
    const $secText = $('.depoimentos-texto');

    // Altera o título
    function changeTitle() {
      const value = confTheme[ref2]['titulo'];
      $secTitle.html(fmtTxt(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'titulo', changeTitle);

    // Altera a cor do título
    function changeTitColor() {
      const color = confTheme[ref]['depoimentos-tit-color'];
      $section[0].style.setProperty('--depoimentos-tit-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tit-color', changeTitColor);

    // Altera o texto
    function changeText() {
      const value = confTheme[ref2]['texto'];
      $secText.html(fmtTxt(value));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'texto', changeText);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref]['depoimentos-txt-color'];
      $section[0].style.setProperty('--depoimentos-txt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-color', changeTxtColor);

    // Altera a cor de fundo do bloco
    function changeBlocoBgColor() {
      const color = confTheme[ref]['depoimento-bg-color'];
      $section[0].style.setProperty('--depoimento-bg-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'bloco-bg-color', changeBlocoBgColor);

    // Altera a cor do texto do bloco
    function changeBlocoTxtColor() {
      const color = confTheme[ref]['depoimento-txt-color'];
      $section[0].style.setProperty('--depoimento-txt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'bloco-txt-color', changeBlocoTxtColor);

    // Altera a cor de destaque do texto
    function changeTxtAltColor() {
      const color = confTheme[ref]['txt-alt-color'];
      $section[0].style.setProperty('--txt-alt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-alt-color', changeTxtAltColor);

    // Altera a cor de fundo do texto
    function changeTxtBgColor() {
      const color = confTheme[ref]['txt-bg-color'];
      $section[0].style.setProperty('--txt-bg-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-bg-color', changeTxtBgColor);
  }
})();

// ------------------------------------
// BOTÃO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'depoimentos-var';
    const ref2 = 'depoimentos';
    const refEvtPrefix = 'lp-evt-depoimentos-';

    // Elementos
    const $secButton = $('.depoimentos-botao');

    // Oculta/Exibe o botão
    function changeBtnShow() {
      const value = confTheme[ref2]['btn-show'];
      value == '1' ? $secButton.removeClass('d-none') : $secButton.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-show', changeBtnShow);

    // Altera a classe do botão
    function changeBtnClass() {
      const value = confTheme[ref2]['btn-class'];
      const styleClass = confTheme['general'][value + '-style'];
      const AnimationClass = confTheme['general'][value + '-animation'];
      $secButton
        .find('.btn')
        .removeClass(btnClassesRem)
        .addClass(value + ' ' + styleClass + ' ' + AnimationClass);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-class', changeBtnClass);

    // Altera o texto do botão
    function changeBtnText() {
      const value = confTheme[ref2]['btn-text'];
      $secButton.find('.btn').text(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-text', changeBtnText);

    // Oculta/Exibe o selo
    function changeSealShow() {
      const value = confTheme[ref2]['seal-show'];
      value == '1'
        ? $secButton.find('.btn-selos').removeClass('d-none')
        : $secButton.find('.btn-selos').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'seal-show', changeSealShow);
  }
})();

// ------------------------------------
// DIVISOR
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'depoimentos-var';
    const ref2 = 'depoimentos';
    const refEvtPrefix = 'lp-evt-depoimentos-';

    // Altera o divisor
    function changeDivider() {
      const value = confTheme[ref2]['divisor'];
      $('.depoimentos .section-divider').addClass('d-none');
      if (value) {
        $('.depoimentos .section-divider.' + value).removeClass('d-none');
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor', changeDivider);

    // Altera a cor do divisor
    function changeDividerColor() {
      const color = confTheme[ref]['divisor-color'];
      $('#depoimentos')[0].style.setProperty('--divisor-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor-color', changeDividerColor);
  }
})();

// ------------------------------------
// LISTA DEPOIMENTOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'depoimentos-var';
    const ref2 = 'depoimentos';
    const refEvtPrefix = 'lp-evt-depoimentos-';

    // Elementos
    const $list = $('#carrosel-depoimentos');

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref2]['lista'];
      if ($list.length > 0) {
        depoimentosDestroySlick();
        $list.html('');
        for (let i = 0; i < lista.length; i++) {
          let $stars = '';
          for (let y = 1; y <= 5; y++) {
            const activeStar = parseInt(lista[i].stars) >= y ? 'active' : '';
            $stars =
              $stars +
              `<label class="${activeStar}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/></svg></label>`;
          }
          const item = `
          <div class="carousel-item depoimento-wrapper" data-aos="fade-up">
            <div class="depoimento">
              <figure class="img depoimento-foto">
                <img src="${lista[i].img}" alt="${lista[i].alt}">
              </figure>
              <div class="depoimento-infos">
                <div class="star-rating depoimento-stars">${$stars}</div>
                <div class="depoimento-nome">${fmtTxt(lista[i].titulo, true)}</div>
                <div class="depoimento-texto">${fmtTxt(lista[i].texto, true)}</div>
              </div>
            </div>
          </div>`;
          $list.append(item);
        }
        depoimentosInitSlick();
        setTimeout(() => {
          $list[0].slick.refresh();
        }, 100);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'lista', changeList);

    // Altera o formato das imagens
    function changeImageFormat() {
      const value = confTheme[ref2]['lista-img-format'];
      $list.removeClass('depoimentos-img-circle').addClass(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'lista-img-format', changeImageFormat);
  }
})();

// ------------------------------------
// LISTA IMAGENS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'depoimentos-var';
    const ref2 = 'depoimentos';
    const refEvtPrefix = 'lp-evt-depoimentos-';

    // Elementos
    const $list = $('#carrosel-depoimentos-imagens');

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref2]['imagens'];
      if ($list.length > 0) {
        depoImagensDestroySlick();
        $list.html('');
        for (let i = 0; i < lista.length; i++) {
          const item = `
          <div class="carousel-item depoimento-imagens-item" data-aos="fade-up">
            <figure class="img img-rounded">
              <img src="${lista[i].img}" alt="${lista[i].alt}">
            </figure>
            <div class="depoimento-imagens-item-titulo">${fmtTxt(lista[i].titulo, true)}</div>
          </div>`;
          $list.append(item);
        }
        depoImagensInitSlick();
        setTimeout(() => {
          $list[0].slick.refresh();
        }, 100);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'imagens', changeList);
  }
})();

// ------------------------------------
// LISTA VÍDEOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'depoimentos-var';
    const ref2 = 'depoimentos';
    const refEvtPrefix = 'lp-evt-depoimentos-';

    // Elementos
    const $list = $('#carrosel-depoimentos-videos');

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref2]['videos'];
      if ($list.length > 0) {
        depoVideosDestroySlick();
        $list.html('');
        for (let i = 0; i < lista.length; i++) {
          const videoUrl = lista[i].video_url;
          const videoID = lista[i].video_id;
          const videoPlataform = lista[i].video_plataforma;
          const item = `
          <div class="carousel-item depoimento-video" data-aos="fade-up">
            <div class="embed embed-4-3 video-load" data-video-id="${videoID}" data-video-plataform="${videoPlataform}">
              ${createVideoThumb(videoID, videoPlataform)}
            </div>
            <div class="depoimento-video-titulo">${fmtTxt(lista[i].titulo, true)}</div>
          </div>`;
          $list.append(item);
        }
        depoVideosInitSlick();
        setTimeout(() => {
          $list[0].slick.refresh();
        }, 100);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'videos', changeList);

    // Altera o formato do vídeo
    function changeVideoFormat() {
      const value = confTheme[ref2]['lista-video-format'];
      $list.find('.embed').removeClass('embed-16-9 embed-4-3 embed-1-1 embed-9-16').addClass(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'lista-video-format', changeVideoFormat);
  }
})();
